import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IEntityApiService } from 'app/projects/entity/src/lib/interfaces/entity.service.interface';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPartialGradeQuery } from '../interfaces/partial-grade.query.interface';
import { PartialGradeCommand } from '../models/partial-grade.command.model';
import { PartialGrade } from '../models/partial-grade.model';

@Injectable()
export class PartialGradeApiService extends EntityService<IPartialGradeQuery, PartialGradeCommand> implements IEntityApiService<PartialGrade> {
    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) environment: IEnvironment) {
        super(http, environment.apiUrl, 'partial-grades');
    }

    getAll(): Observable<PartialGrade[]> {
        throw new Error('Method not implemented.');
    }

    create(entity: PartialGrade): Observable<PartialGrade> {
        const data = new PartialGradeCommand(entity);

        return this._create(data).pipe(map((query) => new PartialGrade(query)));
    }

    read(id: string): Observable<PartialGrade> {
        return this._read(id).pipe(map((query) => new PartialGrade(query)));
    }

    update(entity: PartialGrade): Observable<PartialGrade> {
        const data = new PartialGradeCommand(entity);

        return this._update(entity.id, data).pipe(map((query) => new PartialGrade(query)));
    }

    status(entityId: string, status: string): Observable<PartialGrade> {
        return this.http
            .post<IPartialGradeQuery>(`${this.apiUrl}/${this.entities}/${entityId}/status`, {
                status: status,
            })
            .pipe(map((query) => new PartialGrade(query)));
    }

    bulkUpdate(entities: PartialGradeCommand[]): Observable<PartialGrade[]> {
        return this.http.patch<IPartialGradeQuery[]>(`${this.apiUrl}/${this.entities}`, entities).pipe(map((queries) => queries.map((query) => new PartialGrade(query))));
    }

    bulkUpdateStatus(entityIds: string[], status: string): Observable<PartialGrade[]> {
        return this.http
            .post<IPartialGradeQuery[]>(`${this.apiUrl}/${this.entities}/status/bulk`, {
                ids: entityIds,
                status: status,
            })
            .pipe(map((queries) => queries.map((query) => new PartialGrade(query))));
    }

    delete(id: string): Observable<any> {
        return this._delete(id);
    }
}
